import React from 'react';
import { func, string, bool } from 'prop-types';
import FaqFeedbackButtons from './FaqFeedbackButtons';
import FaqFeedbackForm from './FaqFeedbackForm';

const propTypes = {
  sendFeedback: func.isRequired,
  changeCommentHandler: func.isRequired,
  openForm: func.isRequired,
  comment: string.isRequired,
  feedbackFormOpen: bool.isRequired,
  loading: bool,
};

const defaultProps = {
  comment: '',
  feedbackFormOpen: false,
  loading: false,
};

const FaqFeedback = ({
  sendFeedback,
  changeCommentHandler,
  comment,
  feedbackFormOpen,
  openForm,
  loading,
}) => (
  <div className={loading ? 'faq-feedback loading' : 'faq-feedback'}>
    {feedbackFormOpen ? (
      <FaqFeedbackForm
        sendFeedback={sendFeedback}
        changeCommentHandler={changeCommentHandler}
        comment={comment}
        loading={loading}
      />
    ) : (
      <FaqFeedbackButtons sendFeedback={sendFeedback} openForm={openForm} loading={loading} />
    )}
  </div>
);

FaqFeedback.propTypes = propTypes;
FaqFeedback.defaultProps = defaultProps;

export default FaqFeedback;
